const STATUS_SELECTOR = '.ai-chatbot-header-status-moko';
const STATUS_TEXT = 'Ask me anything';

let statusObserver = null;

const applyStatusText = (status) => {
  if (status.textContent.trim() === STATUS_TEXT) return;
  status.textContent = STATUS_TEXT;
};

const watchStatus = (status) => {
  applyStatusText(status);

  statusObserver?.disconnect();
  statusObserver = new MutationObserver(() => applyStatusText(status));
  statusObserver.observe(status, {
    childList: true,
    characterData: true,
    subtree: true,
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const existingStatus = document.querySelector(STATUS_SELECTOR);

  if (existingStatus) {
    watchStatus(existingStatus);
    return;
  }

  const appObserver = new MutationObserver(() => {
    const status = document.querySelector(STATUS_SELECTOR);
    if (!status) return;

    appObserver.disconnect();
    watchStatus(status);
  });

  appObserver.observe(document.body, { childList: true, subtree: true });
});
